module.exports = __webpack_public_path__ + "img/melissa_bern_ocular.856dff1d.jpg";